import React from 'react';
import { dynastyTokens } from '../../../services/colorService';

const colors = dynastyTokens.colors;

// DD-STAT-CONSOLIDATION Item 3: the shared 2×3 category stat grid for the optimizer
// tiles. OptimizerPlayerTile (absolute-positioned diamond) and OptimizerDashboard's
// renderTile (flow bullpen) keep their distinct SHELLS but consume this ONE grid.
// `stats` = getPlayerCategoryStats(player, categories) → [{abbrev, formatted}]. Renders
// up to 6 as two rows of three. gap/marginTop differ per shell, so they're props.
const OptimizerStatGrid = ({ stats, gap = 10, marginTop = 4 }) => {
  if (!stats || stats.length === 0) return null;
  const r1 = stats.slice(0, 3);
  const r2 = stats.slice(3, 6);
  const cell = (s) => (
    <div key={s.abbrev} style={{ display: 'flex', alignItems: 'baseline', gap: 2 }}>
      <span style={{ fontSize: 9, color: colors.neutral[500], fontWeight: 500 }}>{s.abbrev}</span>
      <span style={{ fontSize: 10, color: '#eab308', fontWeight: 700 }}>{s.formatted}</span>
    </div>
  );
  return (
    <div style={{ marginTop }}>
      <div style={{ display: 'flex', gap }}>{r1.map(cell)}</div>
      {r2.length > 0 && (
        <div style={{ display: 'flex', gap, marginTop: 2 }}>{r2.map(cell)}</div>
      )}
    </div>
  );
};

export default OptimizerStatGrid;
